import { useToastContext } from "../context/ToastContext";

export const useToast = () => useToastContext();
